import { render, staticRenderFns } from "./servicesItem.vue?vue&type=template&id=fe242f8a&scoped=true&"
import script from "./servicesItem.vue?vue&type=script&lang=js&"
export * from "./servicesItem.vue?vue&type=script&lang=js&"
import style0 from "./servicesItem.vue?vue&type=style&index=0&id=fe242f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe242f8a",
  null
  
)

export default component.exports